"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _sharedVariables = require("../../shared-variables");
require("./cross-fade.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * `CrossFade` provides cross-fading animation from the previous child to the new child
 * received by the component. Each child must have a unique childKey. CrossFade handles positioning
 * and stacking the children appropriately.
 */
var CrossFade = function CrossFade(_ref) {
  var children = _ref.children,
    childKey = _ref.childKey;
  var animatorRef = /*#__PURE__*/(0, _react.createRef)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-relative flex-auto"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    component: null
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "sb-crossFade",
    key: childKey,
    nodeRef: animatorRef,
    timeout: {
      enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
      exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: animatorRef
  }, children))));
};
CrossFade.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * A unique string to be used like a React `key` on the current child.
   * As one child is being removed and a new one added, the unique key
   * per child helps the underlying React Transition Group animate the old child out
   * while the new one is animating in.
   */
  childKey: _propTypes["default"].string.isRequired
} : {};
var _default = exports["default"] = CrossFade;